export const GET_SMART_UI_DETAILS_SUCCESS = "GET_SMART_UI_DETAILS_SUCCESS";
export const GET_SMART_UI_DETAILS_LOADING = "GET_SMART_UI_DETAILS_LOADING";
export const GET_SMART_UI_DETAILS_FAILED = "GET_SMART_UI_DETAILS_FAILED";
export const CLEAR_SMART_UI_DETAILS = "CLEAR_SMART_UI_DETAILS";

export const GET_SMARTUI_SCREENSHOTS_LOADING = "GET_SMARTUI_SCREENSHOTS_LOADING";
export const GET_SMARTUI_SCREENSHOTS_SUCCESS = "GET_SMARTUI_SCREENSHOTS_SUCCESS";
export const GET_SMARTUI_SCREENSHOTS_FAILED = "GET_SMARTUI_SCREENSHOTS_FAILED";
